import { css } from "@emotion/core";
import { mq, variables } from "../../../cssInJs";

export default {
  pageTiles: css(
    mq({
      display: "flex",
      justifyContent: "flex-start",
      flexWrap: "wrap",
      margin: "2rem -10px",
      overflow: "hidden",
      // marginLeft: ["-10px", null, null, null, "-2rem", "-5.5rem"],
      // marginRight: ["-10px", null, null, null, "-2rem", "-5.5rem"],
    })
  ),
  pageTile__tile: css(
    mq({
      flex: ["0 0 1000%", null, "0 0 100%"],
      maxWidth: ["100%", null, "100%"],
      padding: "10px",
      paddingTop: "3rem",
      zIndex: 1,

      "&:nth-of-type(even)": {
        marginLeft: "auto",
        ".pageTile__bsyc__bg": mq({
          order: ["0", null, "2"],
        }),
        ".pageTile__bsyc__content__details": mq({
          order: "1",
        }),
      },
      "&:nth-of-type(1)": {
        paddingTop: "10px",
      },
    })
  ),

  tile__content: css({
    // Hover effects for different color themes
    "&.default:hover": {
      "& .pageTile__bsyc__content__details": {
        backgroundColor: variables.secondaryColor,
      },
      "& .pageTile__bsyc__title": {
        color: "#fff !important",
      },
      "& .pageTile__bsyc__subtitle": {
        color: "#fff !important",
      },
      "& .pageTile__bsyc__desc": {
        color: "#fff !important",
      },
      "& .pageTile__bsyc__button": {
        color: "#fff !important",
      },
    },
    "&.violet:hover": {
      "& .pageTile__bsyc__content__details": {
        backgroundColor: "#443e74",
      },
      "& .pageTile__bsyc__title": {
        color: "#fff !important",
      },
      "& .pageTile__bsyc__subtitle": {
        color: "#fff !important",
      },
      "& .pageTile__bsyc__desc": {
        color: "#fff !important",
      },
      "& .pageTile__bsyc__button": {
        color: "#fff !important",
      },
    },
    "&.navy:hover": {
      "& .pageTile__bsyc__content__details": {
        backgroundColor: "#003563",
      },
      "& .pageTile__bsyc__title": {
        color: "#fff !important",
      },
      "& .pageTile__bsyc__subtitle": {
        color: "#fff !important",
      },
      "& .pageTile__bsyc__desc": {
        color: "#fff !important",
      },
      "& .pageTile__bsyc__button": {
        color: "#fff !important",
      },
    },
    "&.steel:hover": {
      "& .pageTile__bsyc__content__details": {
        backgroundColor: "#465577",
      },
      "& .pageTile__bsyc__title": {
        color: "#fff !important",
      },
      "& .pageTile__bsyc__subtitle": {
        color: "#fff !important",
      },
      "& .pageTile__bsyc__desc": {
        color: "#fff !important",
      },
      "& .pageTile__bsyc__button": {
        color: "#fff !important",
      },
    },
    "&.teal:hover": {
      "& .pageTile__bsyc__content__details": {
        backgroundColor: "#007A99",
      },
      "& .pageTile__bsyc__title": {
        color: "#fff !important",
      },
      "& .pageTile__bsyc__subtitle": {
        color: "#fff !important",
      },
      "& .pageTile__bsyc__desc": {
        color: "#fff !important",
      },
      "& .pageTile__bsyc__button": {
        color: "#fff !important",
      },
    },
    "&.tropical-blue:hover": {
      "& .pageTile__bsyc__content__details": {
        backgroundColor: "#009490",
      },
      "& .pageTile__bsyc__title": {
        color: "#fff !important",
      },
      "& .pageTile__bsyc__subtitle": {
        color: "#fff !important",
      },
      "& .pageTile__bsyc__desc": {
        color: "#fff !important",
      },
      "& .pageTile__bsyc__button": {
        color: "#fff !important",
      },
    },
    "&.jade:hover": {
      "& .pageTile__bsyc__content__details": {
        backgroundColor: "#44A788",
      },
      "& .pageTile__bsyc__title": {
        color: "#fff !important",
      },
      "& .pageTile__bsyc__subtitle": {
        color: "#fff !important",
      },
      "& .pageTile__bsyc__desc": {
        color: "#fff !important",
      },
      "& .pageTile__bsyc__button": {
        color: "#fff !important",
      },
    },
    "&.purple:hover": {
      "& .pageTile__bsyc__content__details": {
        backgroundColor: "#916A9B",
      },
      "& .pageTile__bsyc__title": {
        color: "#fff !important",
      },
      "& .pageTile__bsyc__subtitle": {
        color: "#fff !important",
      },
      "& .pageTile__bsyc__desc": {
        color: "#fff !important",
      },
      "& .pageTile__bsyc__button": {
        color: "#fff !important",
      },
    },
    "&.pink:hover": {
      "& .pageTile__bsyc__content__details": {
        backgroundColor: "#E196A6",
      },
      "& .pageTile__bsyc__title": {
        color: "#000 !important",
      },
      "& .pageTile__bsyc__subtitle": {
        color: "#000 !important",
      },
      "& .pageTile__bsyc__desc": {
        color: "#000 !important",
      },
      "& .pageTile__bsyc__button": {
        color: "#000 !important",
      },
    },
    "&.orange:hover": {
      "& .pageTile__bsyc__content__details": {
        backgroundColor: "#F8A775",
      },
      "& .pageTile__bsyc__title": {
        color: "#000 !important",
      },
      "& .pageTile__bsyc__subtitle": {
        color: "#000 !important",
      },
      "& .pageTile__bsyc__desc": {
        color: "#000 !important",
      },
      "& .pageTile__bsyc__button": {
        color: "#000 !important",
      },
    },
    "&.peach:hover": {
      "& .pageTile__bsyc__content__details": {
        backgroundColor: "#FDD58D",
      },
      "& .pageTile__bsyc__title": {
        color: "#000 !important",
      },
      "& .pageTile__bsyc__subtitle": {
        color: "#000 !important",
      },
      "& .pageTile__bsyc__desc": {
        color: "#000 !important",
      },
      "& .pageTile__bsyc__button": {
        color: "#000 !important",
      },
    },
    "&.burnt-orange:hover": {
      "& .pageTile__bsyc__content__details": {
        backgroundColor: "#F06A1D",
      },
      "& .pageTile__bsyc__title": {
        color: "#fff !important",
      },
      "& .pageTile__bsyc__subtitle": {
        color: "#fff !important",
      },
      "& .pageTile__bsyc__desc": {
        color: "#fff !important",
      },
      "& .pageTile__bsyc__button": {
        color: "#fff !important",
      },
    },
    "&.clay:hover": {
      "& .pageTile__bsyc__content__details": {
        backgroundColor: "#B85624",
      },
      "& .pageTile__bsyc__title": {
        color: "#fff !important",
      },
      "& .pageTile__bsyc__subtitle": {
        color: "#fff !important",
      },
      "& .pageTile__bsyc__desc": {
        color: "#fff !important",
      },
      "& .pageTile__bsyc__button": {
        color: "#fff !important",
      },
    },
    "&:hover": {
      
      textDecoration: "none",
      "& .pageTile__bsyc__bg2": {
        transform: "scale(1.02)",
      },
      "& .pageTile__bsyc__content__details": {
        // backgroundColor: "#f26e21",
        // "& .pageTile__bsyc__title": {
        //   '&.default': {
        //     color: "#000",
        //   },
        //   '&.violet': {
        //     color: "#443e74",
        //   },
        //   '&.navy': {
        //     color: "#003563",
        //   },
        //   '&.steel': {
        //     color: "#465577",
        //   },
        //   '&.teal': {
        //     color: "#007A99",
        //   },
        //   '&.tropical-blue': {
        //     color: "#009490",
        //   },
        //   '&.jade': {
        //     color: "#44A788",
        //   },
        //   '&.purple': {
        //     color: "#916A9B",
        //   },
        //   '&.pink': {
        //     color: "#E196A6",
        //   },
        //   '&.orange': {
        //     color: "#F8A775",
        //   },
        //   '&.peach': {
        //     color: "#FDD58D",
        //   },
        //   '&.burnt-orange': {
        //     color: "#F06A1D",
        //   },
        //   '&.clay': {
        //     color: "#B85624",
        //   },
        // },
        // "& .pageTile__bsyc__desc": {
        //   // color: "white",
        // },
        // "& .pageTile__bsyc__dot": {
        //   // borderTopColor: "white",
        // },
        // "& .pageTile__bsyc__button": {
        //   '&.default': {
        //     color: "#000",
        //   },
        //   '&.violet': {
        //     color: "#443e74",
        //   },
        //   '&.navy': {
        //     color: "#003563",
        //   },
        //   '&.steel': {
        //     color: "#465577",
        //   },
        //   '&.teal': {
        //     color: "#007A99",
        //   },
        //   '&.tropical-blue': {
        //     color: "#009490",
        //   },
        //   '&.jade': {
        //     color: "#44A788",
        //   },
        //   '&.purple': {
        //     color: "#916A9B",
        //   },
        //   '&.pink': {
        //     color: "#E196A6",
        //   },
        //   '&.orange': {
        //     color: "#F8A775",
        //   },
        //   '&.peach': {
        //     color: "#FDD58D",
        //   },
        //   '&.burnt-orange': {
        //     color: "#F06A1D",
        //   },
        //   '&.clay': {
        //     color: "#B85624",
        //   },
        // }
      },
    },
  }),

  tile__flip__wrapper: css(
    mq({
      zIndex: "-1",
      display: "flex",
      flexDirection: "row",
      justifyContent: ["center", null, "space-between"],
      width: "100%",
      height: "100%",
      cursor: "pointer",
      position: "relative",
      flexWrap: "wrap",
      alignItems: "center",
    })
  ),

  tile__bg: css(
    mq({
      height: ["230px", null, "380px", "440px"],
      flex: "1 1 300px",
      overflow: "hidden",
      position: "relative",
      boxShadow: "3px 5px 10px rgba(0,0,0,0.3)",
      '@media (min-width: 1280px)': {
        height: '440px',
      },
      '@media (min-width: 1440px)': {
        height: '480px',
      },
      '@media (min-width: 1600px)': {
        height: '540px',
      },
      '@media (min-width: 1920px)': {
        height: '668px',
      },
      '@media (min-width: 2500px)': {
        height: '668px',
      },
    })
  ),

  tile__bg2: css(
    mq({
      height: "100%",
      overflow: "hidden",
      position: "absolute",
      top: "0px",
      width: "100%",
      transition: "all .3s ease-in-out",
      ".slick-next, .slick-prev": {
        display: "none !important",
      },
    })
  ),

  tile__bg2__inner: css(
    mq({
      backgroundPosition: "50%",
      backgroundRepeat: "no-repeat",
      backgroundSize: "cover",
      width: "100%",
      height: ["232px", null, "380px", "440px"],
      '@media (min-width: 1280px)': {
        height: '440px',
      },
      '@media (min-width: 1440px)': {
        height: '480px',
      },
      '@media (min-width: 1600px)': {
        height: '540px',
      },
      '@media (min-width: 1920px)': {
        height: '668px',
      },
      '@media (min-width: 2500px)': {
        height: '668px',
      },
    })
  ),

  tile__details: css(
    mq({
      overflow: "hidden",
      flexGrow: "1",
      textAlign: "left",
      width: "100%",
      bottom: "0",
      backgroundColor: "#FFF",
      color: "#00456e",
      zIndex: 1,
      flex: ["1 1 300px", null, "1 1 400px"],
      maxWidth: ["300px", null, "calc(870% / 21)"],

      height: ["unset", null, "80%"],
      transition: "all .2s ease-in-out",
      position: "relative",
      marginTop: ["-20px", null, "0px"],
      boxShadow: "3px 5px 10px rgba(0,0,0,0.3)",
      "&.even": mq({
        marginLeft: ["0px", null, "-50px"],
        marginRight: "unset",
      }),
      "&.odd": mq({
        marginRight: ["0px", null, "-50px"],
        marginLeft: "unset",
      }),
      
      "& .pageTile__bsyc__container": mq({
        position: ["static,", null, "absolute"],
        top: "50%",
        left: "50%",
        transform: ["none", null, "translate(-50%, -50%)"],
        width: ["100%", null, "80%"],
        padding: ["1rem", null, "0px"],
        "& .pageTile__bsyc__title": {
          fontFamily: '"proxima-nova",sans-serif',
          // fluid 22px @375 -> 44px @1600+; px/vw so the 992px root-size jump can't step it
          fontSize: "clamp(22px, 15.27px + 1.8vw, 44px)",
          textTransform: "capitalize",
          fontWeight: "400",
          lineHeight: 1.1,
          margin: ["0 0 .5rem", null, "0 0 1rem"],
          paddingBottom: [0, null, ".5rem"],
          transition: "color .2s ease-in-out",
          // color: variables.redColor,
        },
        "& .pageTile__bsyc__subtitle": {
          // fluid 15px @375 -> 24px @1600+
          fontSize: "clamp(15px, 12.25px + 0.73vw, 24px)",
          //textTransform: "capitalize",
          fontWeight: "400",
          lineHeight: 1.3,
          margin: ["0 0 .5rem", null, "0 0 .8rem"],
          paddingBottom: [0, null, "1rem"],
          transition: "color .2s ease-in-out",
          // color: variables.redColor,
        },
        "& .pageTile__bsyc__dot": {
          width: "67%",
          marginTop: "0px",
          marginBottom: "0px",
          paddingBottom: "0.5rem",
          borderTopColor: "white",
        },
        "& .pageTile__bsyc__desc": {
          // fluid 14px @375 -> 19px @1600+; unitless line-height (was below font-size, lines overlapped)
          fontSize: "clamp(14px, 12.47px + 0.41vw, 19px)",
          lineHeight: 1.45,
          // minHeight: "70px",
          marginBottom: ["0.5rem", null, "1rem"],
          transition: "color .2s ease-in-out",
          display: "-webkit-box",
          WebkitLineClamp: 3,
          WebkitBoxOrient: "vertical",
          overflow: "hidden",
          textOverflow: "ellipsis",
          // color: variables.darkGrayColor,
        },
        "& .pageTile__bsyc__button": {
          // fluid 13px @375 -> 17px @1600+
          fontSize: "clamp(13px, 11.78px + 0.33vw, 17px)",
          lineHeight: 1.4,
          fontWeight: "700",
          color: "#0081a2",
          transition: "color .2s ease-in-out",
        }
      }),
    })
  ),
};
